import { render, staticRenderFns } from "./tab-iframe.vue?vue&type=template&id=0479d2c2&scoped=true&"
import script from "./tab-iframe.vue?vue&type=script&lang=js&"
export * from "./tab-iframe.vue?vue&type=script&lang=js&"
import style0 from "./tab-iframe.vue?vue&type=style&index=0&id=0479d2c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0479d2c2",
  null
  
)

export default component.exports